import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box, Card, CardMedia, CardContent, TextareaAutosize, Button } from "@material-ui/core";
import ButtonAtom from '../../component/ButtonAtom/index.jsx'
import TextfieldAtom from '../../component/Textfield/index.jsx'
import { makeStyles } from '@material-ui/styles';
import firebase from "../../config/firebase/index";
import CloseIcon from '@mui/icons-material/Close';
import ReactGA from 'react-ga';
import NoFollowMeta from '../../component/NofollowMeta/index.jsx';
import encSecret from '../../config/encryption/index.js';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import Mobile_Browser_Market1 from '../Mobile_Browser_Market1/Mobile_Browser_Market1.js';
import Drawer from '@material-ui/core/Drawer';
import EditPost from './../../pages/Editpost/EditPost';
var CryptoJS = require("crypto-js");



const Suggest_Bid = (props) => {

    const classes = useStyles();
    const [mynumber, setnumber] = useState("");
    const [quantityUnit, setQuantityUnit] = useState("");
    const [quantity, setQuantity] = useState("");
    const [message, setMessage] = useState("");
    const [fixedColor, setFixedColor] = useState('');
    const [price, setPrice] = useState('');
    const [suggest, setSuggest] = useState('');
    const [showCompletion, setShowCompletion] = useState(false);
    const [logIn, setLogIn] = useState(false);
    const [type, setType] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [open, setOpen] = useState(false);
    const [Id, setId] = useState(false);
    const closePopUp = props.closePopUp;
    const dealId = props.dealId;
    const unit = ["kg", "क्विंटल", "टन"];


    const Product = () => {
        if (dealId) {
            firebase.database().ref(`Product/${dealId}`).on('value', deal => {
                const oldDeal = deal.val()
                setSuggest(oldDeal.analytics.suggest ? parseInt(oldDeal.analytics.suggest) : 0);
                // setText(parseInt(oldDeal.analytics.whatsapp))
            })
        }
    }

    const activateQuantityUnit = (unit) => {
        if (unit == "kg")
            changeQuantity("Kg", 0);
        else if (unit == "क्विंटल")
            changeQuantity("Qutil", 1);
        else if (unit == "टन")
            changeQuantity("tan", 2);
    }

    const changeQuantity = (val, num) => {
        setFixedColor(val);
        setQuantityUnit(unit[num]);
    }

    const handleQuantity = (e) => {
        setQuantity(e.target.value);
    }


    useEffect(async () => {
        // setLink(props.link);
        // setFlag(props.methodFlag);
        let user = JSON.parse(localStorage.getItem("user"))[0];
        let id;
        if (!props.suggestId)
            id = await checkCustomer(user);
        else
            id = props.suggestId;
        console.log("IDDDD :::: ", id);
        setId(id);
        if (id) {
            firebase.database().ref(`Customer/${id}`).on('value', deal => {
                let customer = deal.val();
                console.log("::::: :: Customer ::: ", customer);
                // setTimeout(() => {
                setPrice(customer.price);
                let quantity = customer.quantity.split(" ");
                setQuantity(quantity[0]);
                activateQuantityUnit(quantity[1]);
                setMessage(customer.message);
                // }, 400);

            });
        }
        else {
            console.log(props.methodFlag);
            console.log("::::::::::: :::::::::: :::::::::", props)
            Product();
        }

    }, [])

    const newDealCreation = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }

    const formatMonthDate = (num) => {
        return parseInt(num) > 9 ? num : "0" + num;
    }

    const createdAt = () => {
        const today = new Date();
        const date = today.getFullYear() + '-' + formatMonthDate(today.getMonth() + 1) + '-' + formatMonthDate(today.getDate());
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

        const dateTime = date + ' ' + time;

        return dateTime;
    }


    const NoOfSuggest = () => {
        firebase.database().ref(`Product/${dealId}/analytics/suggest`).set(suggest + 1);
    }

    const checkCustomer = (user) => {
        // createCustomer(user, type);
        let cid = false;
        firebase.database().ref("Customer").orderByChild("DealId")
            .equalTo(props.dealId).on("value", snapshot => {
                let customers = snapshot.val();
                for (const key in customers) {
                    if (customers[key].PhoneNo == user.PhoneNo && customers[key].method == "suggest") {
                        cid = key;
                    }
                }

            });
        return cid;
    }

    const createCustomer = (user, type) => {
        const customerRef = firebase.database().ref('Customer');
        const customer = {
            DealId: dealId,
            Name: user.Name,
            PhoneNo: user.PhoneNo,
            img: user.img,
            price: price,
            quantityUnit: props.quantityUnit,
            quantity: quantity + " " + quantityUnit,
            message: message,
            dealSuggestType: type,
            method: "suggest",
            time: createdAt()
        };
        // console.log(customer);
        customerRef.push(customer);
    };

    const updateCustomer = (user, type, sid) => {

        const editRef = firebase.database().ref('Customer/' + sid);
        editRef.update({
            DealId: props.selectedDeal,
            Name: user.Name,
            PhoneNo: user.PhoneNo,
            img: user.img,
            price: price,
            quantityUnit: props.quantityUnit,
            quantity: quantity + " " + quantityUnit,
            message: message,
            dealSuggestType: type,
            method: "suggest",
            time: createdAt()
            // "optInDateTime" : updateWAOptIn && user[0].whatsappOptIn ? new Date().toISOString() : user[0].optInDateTime,
            // "optOutDateTime" : updateWAOptIn && !user[0].whatsappOptIn ? new Date().toISOString() : ""
        });
    };


    const createUser = () => {
        firebase.database().ref("Users").orderByChild("PhoneNo")
            .equalTo(mynumber).once("value", snapshot => {
                const userData = snapshot.val();
                console.log("NewUser ::: ", userData);
                if (!userData) {
                    const UserRef = firebase.database().ref("Users");
                    const user = {
                        City: "",
                        Name: CryptoJS.AES.encrypt("New User", encSecret.key).toString(),
                        PhoneNo: mynumber,
                        dealerFlag: false,
                        img: "",
                        createAt: new Date().toISOString(),
                        updatedAt: new Date().toISOString(),
                        // whatsappOptIn: isToggled ? true : false,
                        // whatsappOpInText: whatsappOpInText
                    };
                    UserRef.push(user);
                    setLocalUser(mynumber);
                    // localStorage.setItem("isLoggedIn", true);
                    // localStorage.setItem("user", JSON.stringify([user]));
                }
                else {
                    setUser(userData);
                }

            });
    }

    const setUser = (userData) => {
        let user;
        for (let key in userData) {
            user = {
                id: key,
                ...userData[key]
            }
        }
        localStorage.setItem("isLoggedIn", true);
        localStorage.setItem("Phone Number", mynumber);
        localStorage.setItem("user", JSON.stringify([user]));
        closePopUpHandler();
        // window.location.reload();
    }

    const setLocalUser = (mynumber) => {
        firebase.database().ref("Users").orderByChild("PhoneNo")
            .equalTo(mynumber).once("value", snapshot => {
                const userData = snapshot.val();
                console.log("NewUser ::: ", userData);
                setUser(userData);
            })
    }



    const closePopUpHandler = () => {
        closePopUp(false)
    };

    const reEnter = () => {
        setLogIn(false);
    }

    const showConfirm = (type) => {
        let user = JSON.parse(localStorage.getItem("user"))[0];

        setType(type);
        console.log("TYPE :::: ", type);
        if (Id)
            updateCustomer(user, type, Id);
        else {
            NoOfSuggest();
            createCustomer(user, type);
        }
        setShowCompletion(true);
    }

    const submit = (type) => {
        console.log(price, quantity, quantityUnit);
        if (price == "" || price == "0")
            setErrorMsg("कीमत खाली या 0 नहीं होनी चाहिए");
        else if (quantity == "" || quantity == "0")
            setErrorMsg("मात्रा खाली या 0 नहीं होनी चाहिए");
        else if (quantityUnit == "")
            setErrorMsg("मात्रा इकाई खाली नहीं होनी चाहिए");
        else {
            setErrorMsg("");
            if (props.loggedIn) {
                let user = JSON.parse(localStorage.getItem("user"))[0];

                setType(type);
                if (Id)
                    updateCustomer(user, type, Id);
                else {
                    NoOfSuggest();
                    createCustomer(user, type);
                }

                setShowCompletion(true)
            }
            else {
                setLogIn(true);
            }
        }

        // closePopUpHandler();
        // createUser(user);
    };



    return (
        <Grid p={2} >
            <NoFollowMeta />

            <Box mt={1} ml={2} mr={2}>
                <CloseIcon style={{ float: "right", fill: "black", position: "absolute", right: "2px", top: "-1px", background: "lightgrey", fontSize: "26px", borderRadius: "50%", padding: "5px" }} onClick={closePopUpHandler} />
                {!logIn ?
                    <Typography variant="h6" className={classes.textAbove} style={{ fontWeight: 600 }} >अपनी बोली दर्ज करें</Typography>

                    : <></>}
            </Box>
            {!showCompletion ?
                logIn ?
                    <Mobile_Browser_Market1 PhoneNo={props.PhoneNo} link={props.link} methodFlag={props.methodFlag} dealId={props.dealId} hide={(val) => showConfirm(val)} reEnter={reEnter} closePopUp={props.closePopUp} type={type} />
                    :
                    <>
                        <Box ml={2} mr={2} mt={1}>
                            <Box>
                                <Typography>अपनी कीमत दर्ज करें</Typography>
                            </Box>
                            <Box style={{ display: "flex", justifyContent: "space-around", backgroundColor: "rgba(83, 37, 47, 0.05)" }}>
                                <Box style={{ width: "10%" }}>
                                    <Typography style={{ fontWeight: 500, fontSize: 20, backgroundColor: "rgba(83, 37, 47, 0.06)", padding: 10 }}>
                                        Rs.
                                    </Typography>
                                </Box>
                                <Box style={{ width: "23%", padding: 0, }}>
                                    <TextfieldAtom placeholder="0"
                                        type="number"
                                        inputMode="numeric"
                                        style={{ fontWeight: 600, height: 50 }}
                                        value={price}
                                        onChange={(e) => setPrice(e.target.value)} />
                                </Box>

                                <Box style={{ width: "67%", backgroundColor: "rgba(83, 37, 47, 0.06)", padding: "20px 0px 0px 10px" }} >
                                    <span style={{ fontSize: 12, fontWeight: 600, marginLeft: "-20px" }}>
                                        {" / " + props.quantityUnit}
                                    </span>
                                </Box>
                            </Box>
                            <Box pt={2}>
                                <Typography>मात्रा</Typography>
                            </Box>
                            <Box>
                                <Box>
                                    <Box style={{ display: "flex", justifyContent: "space-between" }}>

                                        <Box width={"25%"} style={{ backgroundColor: "rgba(83, 37, 47, 0.05)" }}>
                                            <TextfieldAtom placeholder="1"
                                                type="number"
                                                inputMode="numeric"
                                                style={{ fontWeight: 600, }}
                                                value={quantity}
                                                onChange={(e) => setQuantity(e.target.value)} />
                                        </Box>

                                        <Box width={"25%"} ml={1}>
                                            <ButtonAtom mb={3}
                                                name="kg"
                                                cclass={fixedColor == "kg" ? "ActiveButton" : "fixedButton"}
                                                value={quantityUnit}
                                                onClick={() => changeQuantity("kg", 0)}

                                            />
                                        </Box>

                                        <Box width={"25%"} ml={1}>
                                            <ButtonAtom mb={3}
                                                name="क्विंटल"
                                                cclass={fixedColor == "Qutil" ? "ActiveButton" : "fixedButton"}
                                                value={quantityUnit}
                                                onClick={() => changeQuantity("Qutil", 1)}

                                            />
                                        </Box>

                                        <Box width={"25%"} ml={1}>
                                            <ButtonAtom mb={3}
                                                name="टन"
                                                cclass={fixedColor == "tan" ? "ActiveButton" : "fixedButton"}
                                                value={quantityUnit}
                                                onClick={() => changeQuantity("tan", 2)}

                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                            <Box pt={2}>
                                <Typography>डील क्रिएटर के लिए संदेश</Typography>
                            </Box>
                            <Box>
                                <Box style={{ backgroundColor: "rgba(83, 37, 47, 0.05)" }}>
                                    <TextareaAutosize placeholder="अपना संदेश टाइप करें ..."
                                        type="text"
                                        minRows={3}
                                        className={classes.textArea}
                                        inputMode="alphanumeric"
                                        style={{ fontWeight: 500, width: "95%", borderRadius: 5, padding: 10, backgroundColor: "rgba(83, 37, 47, 0.05)", wordWrap: "wrap" }}
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)} />
                                </Box>
                            </Box>
                        </Box>
                        {
                            errorMsg != "" ?
                                <Box p={2}>
                                    <Typography style={{ color: "red", fontSize: 14 }}>{errorMsg}</Typography>
                                </Box>
                                : <></>
                        }
                        <Box style={{ textAlign: "center", paddingTop: 20, paddingBottom: 20 }}>
                            {/* <ButtonAtom
                    name="जमा करें"
                    color={"Red"}
                    onClick={submit}
                /> */}

                            <Button style={{ backgroundColor: "#6da357", fontSize: 20, color: "#fff", margin: 10, width: "43%" }} onClick={() => { setType("buy"); submit("buy") }}><ShoppingCartOutlinedIcon />&nbsp;ख़रीदना है</Button>

                            <Button style={{ backgroundColor: "#df5b4a", fontSize: 20, color: "#fff", margin: 10, width: "43%" }} onClick={() => { setType("sale"); submit("sale") }}><SellOutlinedIcon />&nbsp;बेचना है</Button>

                        </Box>
                    </>
                :
                <>
                    <Box style={{ textAlign: "center", padding: "30% 0 30% 0", fontSize: 20 }}>
                        आपकी बोली सफलतापूर्वक लगा दी गई है
                    </Box>
                    <Box mb={3} ml={5} mr={5} style={{ marginBottom: '100px' }}>
                        <ButtonAtom
                            label="नया सौदा बनाएं"
                            name="नया सौदा बनाएं"
                            // cclass="templateButton2"
                            onClick={() => { newDealCreation('New Deal', 'Click', 'Create New Deal'); setOpen(true); }}
                        />
                    </Box>

                    <div>

                        <React.Fragment>
                            <Drawer className={classes.drawerDesign} anchor={'bottom'} open={open}>
                                <EditPost closePopUp={setOpen} dealId={props.selectedDeal} date={props.date} />
                            </Drawer>
                        </React.Fragment>

                    </div>
                </>}

        </Grid >

    )
};

const useStyles = makeStyles(() => ({
    textAbove: {
        marginTop: '20px',
    },
    otpCenter: {
        display: 'flex',
        justifyContent: 'center',
    },
    drawerDesign: {
        '& .MuiDrawer-paper': {
            paddingTop: 20,
            borderRadius: '20px 20px 0 0',
        }
    },
    headerBrowser: {
        background: '#53252f',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    kishanDetail: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    textCenterSet: {
        display: 'flex',
        alignItems: 'center',
    },
    rotateSHareIcon: {
        transform: 'rotateY(180deg)',
    },
    contetnArrange: {
        width: '100%',
        padding: '10px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        marginTop: '25px',
        '& div': {
            width: '100%'
        }
    },
    commonSectionBuild: {
        maxWidth: 540,
        float: 'none',
        margin: '22px auto',
        marginTop: '-45px',
        height: '435px',
    },
    manageIconCenter: {
        justifyContent: 'center',
        padding: '50px 0 20px',
        boxSizing: 'border-box',
    },
    headerBrowser2: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
        position: 'relative',
        borderColor: '#53252f',
        '& input': {
            paddingLeft: 50,
        }

    },
    headerBrowser3: {
        position: 'absolute',
        top: 25,
        left: 30,
        color: '#53252f'

    },
    textMiddleSet: {
        marginLeft: '18px',
    },
    punnCenter: {
        marginLeft: '20px',
        marginTop: '25px',
    },
    otpBoxUi: {
        justifyContent: 'center',
        margin: '30px 0',
        background: '#fff',
        color: 'black',
        display: 'flex',
        flexDirection: 'column',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    headerBrowser1: {
        background: '#fff',
        color: 'black',
        display: 'flex',
        // flexDirection: 'column',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
        justifyContent: "space-between"

    },
    otpBoxUi1: {

        justifyContent: 'space-between',
    },
    otp: {
        size: 16,
        margin: 'auto 5px',
        '& input': {
            width: '36px !important',
            minHeight: 50,
            border: '0 !important',
            background: 'rgba(83, 37, 47, 0.05)',
            borderRadius: 4,
            color: '#000',
            boxSizing: 'border-box',
            marginBottom: 10,
        }
    },
    topIconImage: {
        marginTop: 'auto 5px',
        position: 'absolute !important',
        left: '90%',
        bottom: '90%',
        transform: 'translate(-50%, -50%)',
        fill: 'white',
        cursor: 'pointer',
    },

    textArea: {
        '&::-webkit-input-placeholder': {
            color: '#8f8f8f',
            fontSize: 10
        },
        '&:-ms-input-placeholder': {
            color: '#8f8f8f',
            fontSize: 10
        },
        '&::placeholder': {
            color: '#8f8f8f',
            fontSize: 10
        },
        '&:-webkit-autofill': {
            boxShadow: '0 0 0 30px inset #eee',
            color: '#53252f',
        },
        '&.Mui-disabled': {
            color: '#53252f',
            textFillColor: '#eee',
        }
    }
}));


export default Suggest_Bid;
